// Animation rules for the landing page only. Mirrored after
// `battleAnimations.css.ts` — install once at LandingPage mount, leave
// installed for the session (next time the user opens `/` the rules
// are already there).
//
// All keyframes are motion-only (transform / opacity); none touch
// layout dimensions, so they're safe under the CSS allowlist
// documented in `docs/frontend/NOTES.md`.

const CSS = `
@keyframes doi-landing-float-a {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-12px); }
}
@keyframes doi-landing-float-b {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-16px); }
}
@keyframes doi-landing-marquee {
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
}
.doi-landing-marquee {
  animation: doi-landing-marquee 26s linear infinite;
}
.doi-landing-marquee-reverse {
  animation: doi-landing-marquee 34s linear infinite reverse;
}
/* Pause the row when the user hovers over it so they can read a card. */
.doi-landing-marquee:hover,
.doi-landing-marquee-reverse:hover {
  animation-play-state: paused;
}
.doi-landing-float-a { animation: doi-landing-float-a 6s ease-in-out infinite; }
.doi-landing-float-b { animation: doi-landing-float-b 6.6s ease-in-out infinite; }

/* The flip-card holder needs perspective so its child's rotateY
   reads as 3D rather than as a 2D x-axis squish. */
.doi-landing-flip {
  perspective: 640px;
}
.doi-landing-flip-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: transform 600ms cubic-bezier(.2, .9, .2, 1);
}
.doi-landing-flip:hover .doi-landing-flip-inner,
.doi-landing-flip:focus-visible .doi-landing-flip-inner,
.doi-landing-flip.is-flipped .doi-landing-flip-inner {
  transform: rotateY(180deg);
}
.doi-landing-flip-face {
  position: absolute;
  inset: 0;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}
.doi-landing-flip-back {
  transform: rotateY(180deg);
}

@media (prefers-reduced-motion: reduce) {
  .doi-landing-marquee,
  .doi-landing-marquee-reverse,
  .doi-landing-float-a,
  .doi-landing-float-b { animation: none; }
  .doi-landing-flip-inner { transition: none; }
}
`;

let installed = false;

export function installLandingAnimations(): void {
  if (installed) return;
  if (typeof document === "undefined") return;
  const el = document.createElement("style");
  el.setAttribute("data-source", "landing-animations");
  el.textContent = CSS;
  document.head.appendChild(el);
  installed = true;
}
